import { Suspense } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router";
import { getIsAuthenticated } from "@/src/auth/store/auth-selectors";
import { RouteFallback } from "@/src/common/components/route-fallback";
import { useAppSelector } from "@/src/common/redux/store";

export function AuthRouteLayout() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const [searchParams] = useSearchParams();

	if (isAuthenticated) {
		const redirect = searchParams.get("redirect") ?? "";
		const safeRedirect = redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/";
		return <Navigate to={safeRedirect} replace />;
	}

	return (
		<Suspense fallback={<RouteFallback />}>
			<Outlet />
		</Suspense>
	);
}
